<template>
  <div id="PurchaseOrderMgmt" class="purchase-mgmt-page">
    <div class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">采购单号</span>
            <el-input placeholder="请输入采购单号" size="small" clearable v-model="params.orderNo" class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">店铺</span>
            <el-select class="filter-select-wide" placeholder="全部" size="small" v-model="params.shopName" filterable clearable :disabled="shopFilterLocked">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="shop in shopOptions" :key="shop.shopType" :label="shop.label" :value="shop.value"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品类型</span>
            <el-select class="filter-select-wide" placeholder="全部" size="small" @change="onProductTypeChange" v-model="productTypeList" filterable multiple collapse-tags clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品颜色</span>
            <el-select placeholder="全部" size="small" v-model="params.productColor" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">机型</span>
            <el-select placeholder="全部" size="small" v-model="productModel" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">SKU</span>
            <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku" class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">采购供应商</span>
            <el-select class="filter-select-wide" placeholder="全部" size="small" @change="onSupplierIdChange" v-model="supplierIdList" filterable multiple collapse-tags clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="supplier in supplierList" :key="supplier.supplierId" :label="supplier.supplierShortName" :value="supplier.supplierId"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">采购日期</span>
            <el-date-picker v-model="date" size="small" type="daterange" range-separator="至" start-placeholder="开始" end-placeholder="结束" :picker-options="pickerOptions" class="filter-date"></el-date-picker>
          </div>
          <div class="filter-item">
            <span class="filter-label">商品类型</span>
            <el-select placeholder="全部" size="small" v-model="params.purchaseProductType" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="产品" :value="1"></el-option>
              <el-option label="纸箱" :value="2"></el-option>
              <el-option label="花熊链子" :value="3"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <el-button type="primary" size="small" icon="el-icon-search" @click="queryBtn">查询</el-button>
          </div>
        </div>

        <div class="batch-toolbar" v-if="multipleSelection.length > 0">
          <el-tooltip
            v-for="action in primaryActions"
            :key="action.key"
            :disabled="!actionDisableTip(action)"
            :content="actionDisableTip(action)"
            placement="top"
          >
            <span class="toolbar-btn-wrap">
              <el-button
                :type="action.danger ? 'danger' : 'primary'"
                :plain="!!action.plain"
                size="small"
                :class="toolbarActionClass(action)"
                :disabled="!!actionDisableTip(action)"
                @click="onActionClick(action)"
              >
                {{ action.label }}
              </el-button>
            </span>
          </el-tooltip>
          <el-tooltip
            v-for="action in trailingActions"
            :key="action.key"
            :disabled="!actionDisableTip(action)"
            :content="actionDisableTip(action)"
            placement="top"
          >
            <span class="toolbar-btn-wrap">
              <el-button
                :type="action.danger ? 'danger' : 'primary'"
                :plain="!!action.plain"
                size="small"
                :class="toolbarActionClass(action)"
                :disabled="!!actionDisableTip(action)"
                @click="onActionClick(action)"
              >
                {{ action.label }}
              </el-button>
            </span>
          </el-tooltip>
          <el-button size="small" class="toolbar-action-btn" @click="cancelSelected">取消选中</el-button>
          <span class="toolbar-tip">已选 {{ multipleSelection.length }} 张采购单</span>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <el-tabs v-model="activeStatusTab" class="status-tabs" @tab-click="onStatusTabChange">
        <el-tab-pane v-for="tab in statusTabs" :key="tab.name" :name="tab.name">
          <span slot="label" class="status-tab-label">
            {{ tab.label }}
            <el-badge v-if="tab.showBadge && statusCounts[tab.name] > 0" :value="statusCounts[tab.name]" class="status-tab-badge"></el-badge>
          </span>
        </el-tab-pane>
      </el-tabs>

      <div class="table-container">
        <el-table ref="table" :data="tableData" border stripe size="mini" :height="screenHeight" v-loading="loading" element-loading-text="加载中..." :row-key="getTableRowKey" :span-method="spanMethod" :cell-class-name="tableCellClassName" show-summary :summary-method="getTableSummaries" header-cell-class-name="table-header-cell" class="mgmt-table purchase-order-table" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="48" align="center" :selectable="rowSelectable"></el-table-column>
          <el-table-column label="序号" width="48" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row._orderRowSpan > 0">{{ getOrderRowIndex(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderNo" label="采购单号" width="150" align="center" class-name="merge-col" show-overflow-tooltip></el-table-column>
          <el-table-column prop="date" label="采购日期" width="80" align="center" class-name="merge-col"></el-table-column>
          <el-table-column prop="purchaseStatusLabel" label="采购状态" width="60" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div>{{ scope.row.purchaseStatusLabel }}</div>
              <div v-if="scope.row._orderRowSpan > 0 && getPendingObligationHints(scope.row).length" class="obligation-hints">
                <span v-for="hint in getPendingObligationHints(scope.row)" :key="hint" class="obligation-hint">{{ hint }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="shopName" label="店铺" width="50" align="center" class-name="merge-col" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierName" label="采购供应商" width="80" class-name="merge-col" show-overflow-tooltip></el-table-column>
          <el-table-column prop="styleName" label="产品名称" width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="unitPrice" label="单价" width="50" align="right" class-name="amount-col">
            <template slot-scope="scope">{{ formatNumber(scope.row.unitPrice) }}</template>
          </el-table-column>
          <el-table-column prop="quantity" label="采购数量" width="60" align="right" class-name="amount-col"></el-table-column>
          <el-table-column prop="arrived" label="已入库数量" width="60" align="right" class-name="amount-col"></el-table-column>
          <el-table-column prop="qualityFail" label="质检不合格" width="50" align="right" class-name="amount-col"></el-table-column>
          <el-table-column prop="exchangedQty" label="换货数量" width="50" align="right" class-name="amount-col"></el-table-column>
          <el-table-column prop="outOfStock" label="缺货" width="50" align="right" class-name="amount-col"></el-table-column>
          <el-table-column prop="overStock" label="多到数量" width="50" align="right" class-name="amount-col"></el-table-column>
          <el-table-column prop="totalPrice" label="总价" width="80" align="right" class-name="amount-col">
            <template slot-scope="scope">{{ formatNumber(scope.row.totalPrice) }}</template>
          </el-table-column>
          <el-table-column prop="taxRate" label="税率" width="50" align="right">
            <template slot-scope="scope">{{ formatTaxRate(scope.row.taxRate) }}</template>
          </el-table-column>
          <el-table-column prop="taxAmount" label="税额" width="65" align="right" class-name="amount-col">
            <template slot-scope="scope">{{ formatNumber(scope.row.taxAmount) }}</template>
          </el-table-column>
          <el-table-column prop="freight" label="运费" width="60" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">{{ formatNumber(scope.row.freight) }}</template>
          </el-table-column>
          <el-table-column prop="platformDiscount" label="平台优惠" width="60" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">{{ formatNumber(scope.row.platformDiscount) }}</template>
          </el-table-column>
          <el-table-column prop="returnExchangeFee" label="退换货费" width="60" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">{{ formatNumber(scope.row.returnExchangeFee) }}</template>
          </el-table-column>
          <el-table-column prop="otherFee" label="其他费用" width="60" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">{{ formatNumber(scope.row.otherFee) }}</template>
          </el-table-column>
          <el-table-column prop="payableAmount" label="应付金额" width="80" align="right" class-name="merge-col amount-col highlight-amount">
            <template slot-scope="scope">
              <span class="money-text">{{ formatNumber(scope.row.payableAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualPaidAmount" label="实付金额" width="80" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">
              <span class="money-text primary">{{ formatNumber(scope.row.actualPaidAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amountDiff" label="差额" width="65" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">
              <span class="money-text" :class="getAmountDiffClass(scope.row.amountDiff)">{{ formatAmountDiff(scope.row.amountDiff) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="expectedRefundAmount" label="应退款金额" width="65" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">{{ formatRefundAmount(scope.row.expectedRefundAmount) }}</template>
          </el-table-column>
          <el-table-column prop="actualRefundAmount" label="实退款金额" width="65" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">{{ formatRefundAmount(scope.row.actualRefundAmount) }}</template>
          </el-table-column>
          <el-table-column prop="orderPlatform" label="下单平台" width="50" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.orderPlatform" size="mini" :type="scope.row.orderPlatform === '对公' ? 'warning' : 'info'" effect="plain">
                {{ scope.row.orderPlatform }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column prop="returnStatusLabel" label="退货状态" width="60" align="center" class-name="merge-col"></el-table-column>
          <el-table-column prop="refundStatusLabel" label="退款状态" width="60" align="center" class-name="merge-col"></el-table-column>
          <el-table-column prop="orderConfirmProof" label="订单证明" width="80" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="getProofImageList(scope.row, 'orderConfirmProof').length" class="proof-thumb-list">
                <el-image v-for="(url, index) in getProofImageList(scope.row, 'orderConfirmProof')" :key="url + '-' + index" :src="url" :preview-src-list="getProofImageList(scope.row, 'orderConfirmProof')" fit="cover" class="proof-thumb"></el-image>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="logisticsNo" label="物流编号" min-width="150" align="left" class-name="merge-col logistics-no-col">
            <template slot-scope="scope">
              <div v-if="getLogisticsNoList(scope.row).length" class="logistics-no-list">
                <div v-for="(no, index) in getLogisticsNoList(scope.row)" :key="no + '-' + index" class="logistics-no-item">
                  {{ no }}
                </div>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip class-name="merge-col">
            <template slot-scope="scope">{{ scope.row.remark || "-" }}</template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center" fixed="right" class-name="merge-col action-col">
            <template slot-scope="scope">
              <div v-if="scope.row._orderRowSpan > 0" class="action-cell">
                <el-button v-if="canEditOrder(scope.row)" type="text" size="mini" @click="openEditOrder(scope.row)">编辑</el-button>
                <el-button v-if="canManageOrderConfirmProof(scope.row)" type="text" size="mini" @click="openProofUpload(scope.row)">
                  {{ getOrderConfirmProofButtonLabel(scope.row) }}
                </el-button>
                <el-button type="text" size="mini" @click="openPurchaseRecords(scope.row)">采购记录</el-button>
                <el-button type="text" size="mini" @click="openReceiptHistory(scope.row)">收货记录</el-button>
                <el-button type="text" size="mini" @click="openPurchaseMaterials(scope.row)">采购材料</el-button>
                <el-button type="text" size="mini" @click="showOpreateLog(scope.row)">操作记录</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-box">
        <el-pagination layout="prev, pager, next" background prev-text="上一页" next-text="下一页" :current-page.sync="currentPage" :page-size="params.pageSize" :total="total" @current-change="onPageChange"></el-pagination>
      </div>
    </div>

    <confirm-receipt-dialog ref="receiptDialog" @success="onActionSuccess"></confirm-receipt-dialog>
    <receipt-history-dialog ref="receiptHistoryDialog" @success="onActionSuccess"></receipt-history-dialog>
    <create-exchange-dialog ref="exchangeDialog" @success="onActionSuccess"></create-exchange-dialog>
    <void-receipt-dialog ref="voidReceiptDialog" @success="onActionSuccess"></void-receipt-dialog>
    <receipt-defect-dialog ref="receiptDefectDialog"></receipt-defect-dialog>
    <inbound-defect-action-dialog ref="defectActionDialog" @success="onActionSuccess"></inbound-defect-action-dialog>
    <edit-purchase-order-dialog ref="editOrderDialog" @success="onActionSuccess"></edit-purchase-order-dialog>
    <create-pay-order-from-purchase-order-dialog ref="createPayOrderDialog" @success="onActionSuccess"></create-pay-order-from-purchase-order-dialog>
    <upload-logistics-waybill-dialog ref="uploadLogisticsDialog" @success="onActionSuccess"></upload-logistics-waybill-dialog>

    <el-dialog :title="proofUploadTitle" :visible.sync="proofUploadVisible" width="640px" custom-class="purchase-order-proof-dialog" :close-on-click-modal="false" append-to-body @opened="onProofUploadDialogOpened" @closed="onProofUploadDialogClosed">
      <div ref="proofPastePanel" class="proof-upload-panel" tabindex="0" v-loading="proofUploading">
        <div class="proof-upload-list">
          <div v-for="(url, index) in proofUploadUrls" :key="url + '-' + index" class="proof-upload-item">
            <el-image :src="url" fit="cover" class="proof-upload-image"></el-image>
            <i class="el-icon-error proof-upload-remove" @click="removeProofUploadImage(index)"></i>
          </div>
          <el-upload class="proof-upload-add" action="/biz/oss/upload" name="file" accept="image/*" :data="{ bizModule: 'purchaseOrder' }" :show-file-list="false" :before-upload="beforeProofImageUpload" :on-success="handleProofUploadSuccess" :disabled="proofUploading">
            <div class="proof-upload-trigger">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <span class="proof-upload-text">添加图片</span>
            </div>
          </el-upload>
        </div>
        <div class="proof-upload-tip">支持 JPG、PNG、GIF、WEBP、BMP；可上传多张，可在本弹窗内 Ctrl+V 粘贴截图</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="proofUploadVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveProofUpload" :loading="proofUploadSaving">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="采购记录" :visible.sync="purchaseRecordsVisible" width="1200px">
      <el-table :data="purchaseRecords" border stripe size="mini" max-height="420" v-loading="purchaseRecordsLoading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="date" label="采购日期" width="100" align="center"></el-table-column>
        <el-table-column prop="shopName" label="店铺" width="70" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" label="产品名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sku" label="SKU" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchaseColorName" label="颜色" width="80" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="model" label="机型" width="80" align="left"></el-table-column>
        <el-table-column prop="purchaseQuantity" label="采购数量" width="80" align="right"></el-table-column>
        <el-table-column prop="arrived" label="入库数量" width="80" align="right"></el-table-column>
        <el-table-column prop="purchaseStatusLabel" label="采购状态" width="90" align="center"></el-table-column>
        <el-table-column prop="orderNo" label="采购单号" width="150" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="purchaseRecordsVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="采购材料" :visible.sync="purchaseMaterialVisible" width="920px">
      <el-table :data="purchaseMaterialList" border stripe size="mini" max-height="420" show-summary :summary-method="getPurchaseMaterialSummaries" v-loading="purchaseMaterialLoading">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="materialName" label="材料名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchaseColorName" label="采购颜色" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="boxSpec" label="规格" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="unitPrice" label="单价" width="80" align="right">
          <template slot-scope="scope">{{ formatNumber(scope.row.unitPrice) }}</template>
        </el-table-column>
        <el-table-column prop="quantity" label="数量" width="80" align="right"></el-table-column>
        <el-table-column prop="totalAmount" label="金额" width="88" align="right">
          <template slot-scope="scope">{{ formatNumber(scope.row.totalAmount) }}</template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="purchaseMaterialVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="opreateLogVisible" width="960px">
      <el-table :data="operateHistory" border stripe size="mini" max-height="420" v-loading="opreateLogLoading">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="90"></el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="170"></el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="120"></el-table-column>
        <el-table-column prop="bussinessId" label="业务ID" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="操作详情" min-width="240" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="opreateLogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules, ossModules } from "@r";
import { activeProducts, allActiveProducts, colors, models } from "../../utils/constant.js";
import ConfirmReceiptDialog from "./ConfirmReceiptDialog.vue";
import ReceiptHistoryDialog from "./ReceiptHistoryDialog.vue";
import CreateExchangeDialog from "./CreateExchangeDialog.vue";
import VoidReceiptDialog from "./VoidReceiptDialog.vue";
import ReceiptDefectDialog from "./ReceiptDefectDialog.vue";
import InboundDefectActionDialog from "./InboundDefectActionDialog.vue";
import EditPurchaseOrderDialog from "./EditPurchaseOrderDialog.vue";
import CreatePayOrderFromPurchaseOrderDialog from "./CreatePayOrderFromPurchaseOrderDialog.vue";
import UploadLogisticsWaybillDialog from "./UploadLogisticsWaybillDialog.vue";
import { PURCHASE_STATUS, REFUND_STATUS, RETURN_STATUS, STATUS_TABS, RECEIPT_ALLOWED_STATUSES, isReceiptAllowedStatus, isRefundStatusBlocked, isReturnStatusBlocked, canInitiateRefundOrReturnPurchaseStatus } from "./purchaseOrderStatus.js";

const DEFECT_ACTION_KEYS = ["startReturnRefund", "skipReturnAndRefund", "skipReturnNeedRefund", "startRefund", "startReturn", "confirmInbound"];

const STATUS_ACTIONS = [
  { key: "createPayOrder", label: "生成支付订单", statuses: [PURCHASE_STATUS.PENDING_ORDER], btnClass: "action-btn-long-label action-btn-create-pay-order" },
  { key: "confirmReceipt", label: "新增收货单", statuses: RECEIPT_ALLOWED_STATUSES, btnClass: "action-btn-long-label action-btn-create-receipt" },
  { key: "uploadLogisticsWaybill", label: "上传物流面单", statuses: [PURCHASE_STATUS.PENDING_RECEIVE], btnClass: "action-btn-long-label" },
  { key: "createExchange", label: "新增换货单", statuses: [PURCHASE_STATUS.PENDING_RECEIVE], btnClass: "action-btn-long-label action-btn-create-exchange" },
  {
    key: "voidReceipt",
    label: "撤回收货",
    statuses: [
      PURCHASE_STATUS.PENDING_ORDER,
      PURCHASE_STATUS.PENDING_PAY,
      PURCHASE_STATUS.PENDING_RECEIVE,
      PURCHASE_STATUS.INBOUND_DEFECT,
      PURCHASE_STATUS.COMPLETED,
    ],
    btnClass: "action-btn-long-label",
  },
  {
    key: "viewReceiptDefect",
    label: "收货缺陷",
    statuses: [
      PURCHASE_STATUS.PENDING_RECEIVE,
      PURCHASE_STATUS.INBOUND_DEFECT,
      PURCHASE_STATUS.PENDING_REFUND,
      PURCHASE_STATUS.PENDING_RETURN,
      PURCHASE_STATUS.COMPLETED,
    ],
  },
  { key: "startReturnRefund", label: "发起退货退款", statuses: [PURCHASE_STATUS.INBOUND_DEFECT], btnClass: "action-btn-long-label" },
  { key: "startRefund", label: "发起退款", statuses: [PURCHASE_STATUS.INBOUND_DEFECT, PURCHASE_STATUS.PENDING_REFUND] },
  { key: "startReturn", label: "发起退货", statuses: [PURCHASE_STATUS.INBOUND_DEFECT] },
  { key: "confirmInbound", label: "确认入库", statuses: [PURCHASE_STATUS.INBOUND_DEFECT] },
  {
    key: "skipReturnNeedRefund",
    label: "无需退货仅退款",
    statuses: [PURCHASE_STATUS.INBOUND_DEFECT],
    danger: true,
    trailing: true,
    btnClass: "action-btn-long-label action-btn-skip-return-refund",
  },
  {
    key: "skipReturnAndRefund",
    label: "无需退货退款",
    statuses: [PURCHASE_STATUS.INBOUND_DEFECT],
    danger: true,
    trailing: true,
    btnClass: "action-btn-long-label action-btn-skip-return-refund",
  },
  {
    key: "void",
    label: "作废",
    statuses: [PURCHASE_STATUS.PENDING_ORDER],
    danger: true,
    plain: true,
  },
];

const EXTRA_ACTIONS = [
  { key: "startRefund", label: "发起退款", plain: true },
  { key: "startReturn", label: "发起退货", plain: true },
];

const ORDER_MERGE_PROPS = ["orderNo", "date", "shopName", "supplierName", "freight", "platformDiscount", "returnExchangeFee", "otherFee", "payableAmount", "actualPaidAmount", "amountDiff", "expectedRefundAmount", "actualRefundAmount", "orderPlatform", "orderConfirmProof", "logisticsNo", "remark", "purchaseStatusLabel", "refundStatusLabel", "returnStatusLabel"];

const SHOP_FILTER_OPTIONS = [
  { label: "灵柚", value: "灵柚", shopType: "1" },
  { label: "萧发", value: "萧发", shopType: "2" },
  { label: "誉腾", value: "誉腾", shopType: "3" },
  { label: "甄昂", value: "甄昂", shopType: "4" },
  { label: "众联", value: "众联", shopType: "8" },
];

function resolveHeaderShopName() {
  const shopType = localStorage.getItem("shopType") || "";
  const matched = SHOP_FILTER_OPTIONS.find(item => item.shopType === String(shopType));
  return matched ? matched.value : "";
}

const ACTION_COLUMN_LABEL = "操作";

export default {
  components: {
    ConfirmReceiptDialog,
    ReceiptHistoryDialog,
    CreateExchangeDialog,
    VoidReceiptDialog,
    ReceiptDefectDialog,
    InboundDefectActionDialog,
    EditPurchaseOrderDialog,
    CreatePayOrderFromPurchaseOrderDialog,
    UploadLogisticsWaybillDialog,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      screenHeight: document.body.clientHeight - 64 - 120 - 100,
      productList: localStorage.getItem("shopType") == 6 ? allActiveProducts : activeProducts,
      colorList: colors,
      modelList: models,
      supplierList: [],
      activeStatusTab: String(PURCHASE_STATUS.PENDING_ORDER),
      statusTabs: STATUS_TABS,
      statusCounts: {
        [String(PURCHASE_STATUS.PENDING_ORDER)]: 0,
        [String(PURCHASE_STATUS.PENDING_PAY)]: 0,
        [String(PURCHASE_STATUS.PENDING_RECEIVE)]: 0,
        [String(PURCHASE_STATUS.INBOUND_DEFECT)]: 0,
        [String(PURCHASE_STATUS.PENDING_REFUND)]: 0,
        [String(PURCHASE_STATUS.PENDING_RETURN)]: 0,
      },
      multipleSelection: [],
      actionLoading: false,
      purchaseRecordsVisible: false,
      purchaseRecordsLoading: false,
      purchaseRecords: [],
      purchaseMaterialVisible: false,
      purchaseMaterialLoading: false,
      purchaseMaterialList: [],
      opreateLogVisible: false,
      opreateLogLoading: false,
      operateHistory: [],
      proofUploadVisible: false,
      proofUploadTitle: "",
      proofUploadUrls: [],
      proofUploadRow: null,
      proofUploadSaving: false,
      proofUploading: false,

      productTypeList: [],
      supplierIdList: [],
      productModel: "",
      date: [],
      shopOptions: SHOP_FILTER_OPTIONS,
      shopFilterLocked: !!resolveHeaderShopName(),

      params: {
        orderNo: "",
        shopName: resolveHeaderShopName(),
        productTypeList: "[]",
        supplierIdList: "[]",
        productColor: "",
        productModel: "",
        sku: "",
        purchaseProductType: "",
        beginIndex: 0,
        pageSize: 50,
      },

      pickerOptions: {
        shortcuts: [
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    selectedStatuses() {
      const set = {};
      (this.multipleSelection || []).forEach(row => {
        const status = this.resolveRowStatus(row);
        if (status !== null && status !== undefined && status !== "") {
          set[Number(status)] = true;
        }
      });
      return Object.keys(set).map(Number);
    },
    availableActions() {
      if (!this.multipleSelection.length) return [];
      const statuses = this.selectedStatuses;
      const actions = STATUS_ACTIONS.filter(action => action.statuses.some(s => statuses.includes(s)));
      const actionKeys = actions.map(action => action.key);

      if (!actionKeys.includes("startRefund") && this.multipleSelection.some(row => this.canStartRefund(row))) {
        actions.push(EXTRA_ACTIONS[0]);
      }
      if (!actionKeys.includes("startReturn") && this.multipleSelection.some(row => this.canStartReturn(row))) {
        actions.push(EXTRA_ACTIONS[1]);
      }
      return actions;
    },
    primaryActions() {
      return this.availableActions.filter(action => !action.trailing);
    },
    trailingActions() {
      return this.availableActions.filter(action => !!action.trailing);
    },
  },
  mounted() {
    this.fetchSuppliers();
    this.relayoutTable();
    this.getData();
    this.$eventBus && this.$eventBus.$on && this.$eventBus.$on("resize", this.relayoutTable);
    window.addEventListener("resize", this.relayoutTable);
  },
  beforeDestroy() {
    this.$eventBus && this.$eventBus.$off && this.$eventBus.$off("resize", this.relayoutTable);
    window.removeEventListener("resize", this.relayoutTable);
  },
  watch: {
    productModel: {
      handler(newValue) {
        let blankReg = new RegExp(" ", "igm");
        this.params.productModel = (newValue || "").replace(blankReg, "");
      },
    },
    "multipleSelection.length"() {
      this.relayoutTable();
    },
  },
  methods: {
    toolbarActionClass(action) {
      const classes = ["toolbar-action-btn"];
      const extra = (action && action.btnClass) || "";
      if (extra) {
        String(extra)
          .split(/\s+/)
          .filter(Boolean)
          .forEach(cls => classes.push(cls));
      }
      return classes;
    },
    resolveRowStatus(row) {
      if (!row) return null;
      if (row.purchaseStatus !== null && row.purchaseStatus !== undefined && row.purchaseStatus !== "") {
        return Number(row.purchaseStatus);
      }
      if (this.activeStatusTab && this.activeStatusTab !== "all") {
        return Number(this.activeStatusTab);
      }
      return null;
    },
    /** 整单缺陷合计（操作资格用）；兼容旧数据回退到当前行或同单各行汇总 */
    getOrderDefectQty(row) {
      if (!row) {
        return { qualityFail: 0, outOfStock: 0, overStock: 0 };
      }
      if (row.orderQualityFail !== undefined || row.orderOutOfStock !== undefined || row.orderOverStock !== undefined) {
        return {
          qualityFail: Number(row.orderQualityFail) || 0,
          outOfStock: Number(row.orderOutOfStock) || 0,
          overStock: Number(row.orderOverStock) || 0,
        };
      }
      const orderId = row.orderId || row._id;
      if (!orderId) {
        return {
          qualityFail: Number(row.qualityFail) || 0,
          outOfStock: Number(row.outOfStock) || 0,
          overStock: Number(row.overStock) || 0,
        };
      }
      const peers = (this.tableData || []).filter(item => (item.orderId || item._id) === orderId);
      if (!peers.length) {
        return {
          qualityFail: Number(row.qualityFail) || 0,
          outOfStock: Number(row.outOfStock) || 0,
          overStock: Number(row.overStock) || 0,
        };
      }
      return peers.reduce(
        (acc, item) => ({
          qualityFail: acc.qualityFail + (Number(item.qualityFail) || 0),
          outOfStock: acc.outOfStock + (Number(item.outOfStock) || 0),
          overStock: acc.overStock + (Number(item.overStock) || 0),
        }),
        { qualityFail: 0, outOfStock: 0, overStock: 0 }
      );
    },
    canStartRefund(row) {
      if (!row || !canInitiateRefundOrReturnPurchaseStatus(this.resolveRowStatus(row))) return false;
      if (isRefundStatusBlocked(row.refundStatus)) return false;
      const defect = this.getOrderDefectQty(row);
      return defect.outOfStock > 0 || defect.qualityFail > 0;
    },
    canCreateRefundFromPending(row) {
      if (!row || this.resolveRowStatus(row) !== PURCHASE_STATUS.PENDING_REFUND) return false;
      const refundStatus = Number(row.refundStatus);
      if (!(refundStatus === REFUND_STATUS.PENDING || row.refundStatus === "待退款")) return false;
      const defect = this.getOrderDefectQty(row);
      return defect.qualityFail > 0 || defect.outOfStock > 0;
    },
    canStartReturn(row) {
      if (!row || !canInitiateRefundOrReturnPurchaseStatus(this.resolveRowStatus(row))) return false;
      if (isReturnStatusBlocked(row.returnStatus)) return false;
      const defect = this.getOrderDefectQty(row);
      const hasOver = defect.overStock > 0 && !row.overStockConfirmed && !row.overStockReturned;
      // 与后端 canStartReturnOnOrder 对齐：可能有待补退货质检，弹窗内再按 disposition 精筛
      const returnCode = Number(row.returnStatus);
      const hasPendingQualityReturn =
        defect.qualityFail > 0 && (returnCode === RETURN_STATUS.NONE || row.returnStatus === "" || row.returnStatus == null);
      return hasOver || hasPendingQualityReturn;
    },
    /** 「发起退货」：未处理多到或待补退货质检；未处置质检引导「发起退货退款」 */
    actionDisableTip(action) {
      if (!action) return "";
      if (action.key === "createExchange") {
        const rows = this.getRowsForAction(action);
        if (!rows.length) {
          const hasPending = (this.multipleSelection || []).some(row => this.canConfirmReceipt(row));
          if (hasPending) {
            return "所选采购单没有可换货的质检不合格数量（请先通过收货单录入质检不合格）";
          }
          return "";
        }
        const orderIds = [
          ...new Set(
            rows.map(row => String(row.purchaseOrderId || row.orderId || row._id || "")).filter(Boolean)
          ),
        ];
        if (orderIds.length > 1) {
          return "每次只能对一张采购单新增换货单";
        }
        return "";
      }
      if (action.key === "uploadLogisticsWaybill") {
        if ((this.multipleSelection || []).length !== 1) {
          return "每次只能对一张采购单上传物流面单";
        }
        return "";
      }
      if (action.key === "startReturn") {
        if ((this.multipleSelection || []).some(row => this.canStartReturn(row))) return "";
        const hasQuality = (this.multipleSelection || []).some(row => this.getOrderDefectQty(row).qualityFail > 0);
        if (hasQuality) {
          return "未处置的质检不合格请使用「发起退货退款」；「发起退货」用于未处理多到，或退货退款后待补建的退货";
        }
        return "「发起退货」用于未处理的多到，或已选退货退款且待补建的质检退货";
      }
      if (action.key === "confirmInbound") {
        if ((this.multipleSelection || []).some(row => this.canConfirmInbound(row))) return "";
        const rows = this.multipleSelection || [];
        const hasOverConfirmed = rows.some(row => {
          const defect = this.getOrderDefectQty(row);
          return defect.overStock > 0 && !!row.overStockConfirmed;
        });
        if (hasOverConfirmed) {
          return "多到已确认入库；「确认入库」仅用于未处理的多到";
        }
        const hasOverReturned = rows.some(row => {
          const defect = this.getOrderDefectQty(row);
          return defect.overStock > 0 && !!row.overStockReturned;
        });
        if (hasOverReturned) {
          return "多到已走退货；「确认入库」仅用于未处理的多到";
        }
        const hasQuality = rows.some(row => this.getOrderDefectQty(row).qualityFail > 0);
        if (hasQuality) {
          return "质检不合格请使用「发起退货退款」；「确认入库」仅用于未处理的多到";
        }
        return "「确认入库」仅用于未处理的多到数量";
      }
      return "";
    },
    canStartReturnRefund(row) {
      if (!row || this.resolveRowStatus(row) !== PURCHASE_STATUS.INBOUND_DEFECT) return false;
      return this.getOrderDefectQty(row).qualityFail > 0;
    },
    canSkipReturnAndRefund(row) {
      if (!row || this.resolveRowStatus(row) !== PURCHASE_STATUS.INBOUND_DEFECT) return false;
      return this.getOrderDefectQty(row).qualityFail > 0;
    },
    canSkipReturnNeedRefund(row) {
      if (!row || this.resolveRowStatus(row) !== PURCHASE_STATUS.INBOUND_DEFECT) return false;
      return this.getOrderDefectQty(row).qualityFail > 0;
    },
    getPendingObligationHints(row) {
      if (!row || this.resolveRowStatus(row) !== PURCHASE_STATUS.INBOUND_DEFECT) return [];
      const defect = this.getOrderDefectQty(row);
      const hints = [];
      const returnStatus = Number(row.returnStatus);
      const refundStatus = Number(row.refundStatus);
      const refundDone = refundStatus === REFUND_STATUS.DONE;
      const returnDone = returnStatus === RETURN_STATUS.DONE;
      const refundPending = refundStatus === REFUND_STATUS.PENDING;
      const returnPending = returnStatus === RETURN_STATUS.PENDING;

      if (defect.qualityFail > 0) {
        if (refundPending || returnPending) {
          hints.push("质检处理中");
        } else if (!refundDone && !returnDone) {
          // 粗略提示：未完成退款/退货闭环时仍可能待处理（含无需退货退款后的缺货等）
          hints.push("质检待处理");
        }
      }
      if (defect.outOfStock > 0) {
        if (refundPending) hints.push("缺货待退款确认");
        else if (!refundDone) hints.push("缺货待退款");
      }
      if (defect.overStock > 0 && !row.overStockConfirmed && !row.overStockReturned) {
        if (returnPending) hints.push("多到待退货确认");
        else if (!returnDone) hints.push("多到待退货或确认入库");
      }
      return hints;
    },
    canConfirmInbound(row) {
      if (!row || this.resolveRowStatus(row) !== PURCHASE_STATUS.INBOUND_DEFECT) return false;
      return this.getOrderDefectQty(row).overStock > 0 && !row.overStockConfirmed && !row.overStockReturned;
    },
    canConfirmReceipt(row) {
      return isReceiptAllowedStatus(this.resolveRowStatus(row));
    },
    canCreateExchange(row) {
      if (!row || this.resolveRowStatus(row) !== PURCHASE_STATUS.PENDING_RECEIVE) return false;
      return this.getOrderDefectQty(row).qualityFail > 0;
    },
    canVoidReceipt(row) {
      if (!row) return false;
      const status = this.resolveRowStatus(row);
      if (
        ![
          PURCHASE_STATUS.PENDING_ORDER,
          PURCHASE_STATUS.PENDING_PAY,
          PURCHASE_STATUS.PENDING_RECEIVE,
          PURCHASE_STATUS.INBOUND_DEFECT,
          PURCHASE_STATUS.COMPLETED,
        ].includes(status)
      ) {
        return false;
      }
      if (isRefundStatusBlocked(row.refundStatus) || isReturnStatusBlocked(row.returnStatus)) {
        return false;
      }
      return true;
    },
    canViewReceiptDefect(row) {
      const status = this.resolveRowStatus(row);
      return [
        PURCHASE_STATUS.PENDING_RECEIVE,
        PURCHASE_STATUS.INBOUND_DEFECT,
        PURCHASE_STATUS.PENDING_REFUND,
        PURCHASE_STATUS.PENDING_RETURN,
        PURCHASE_STATUS.COMPLETED,
      ].includes(status);
    },
    fetchSuppliers() {
      requestModules.fetchSuppliers({ beginIndex: 0, pageSize: 1000 }).then(res => {
        this.supplierList = res.ldata || [];
      });
    },
    calculateHeight() {
      let panel = this.$refs.tablePanel;
      if (!panel) return;
      let tabs = panel.querySelector(".status-tabs");
      let pagination = panel.querySelector(".pagination-box");
      let panelStyle = window.getComputedStyle(panel);
      let paddingTop = parseFloat(panelStyle.paddingTop) || 0;
      let paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
      let available = panel.clientHeight - paddingTop - paddingBottom - (tabs ? tabs.offsetHeight + 12 : 0) - (pagination ? pagination.offsetHeight : 0);
      this.screenHeight = Math.max(available, 200);
    },
    relayoutTable() {
      this.$nextTick(() => {
        this.calculateHeight();
        this.$nextTick(() => {
          if (this.$refs.table && this.$refs.table.doLayout) {
            this.$refs.table.doLayout();
          }
        });
      });
    },
    onProductTypeChange(checkList) {
      let isAllChecked = false;
      checkList.forEach(productType => productType == "" && (isAllChecked = true));
      if (isAllChecked) {
        this.productTypeList = [];
        this.productList.forEach(product => this.productTypeList.push(product.productType));
      }
    },
    onSupplierIdChange(checkList) {
      let isAllChecked = false;
      checkList.forEach(supplierId => supplierId == "" && (isAllChecked = true));
      if (isAllChecked) {
        this.supplierIdList = [];
        this.supplierList.forEach(supplier => this.supplierIdList.push(String(supplier.supplierId)));
      }
    },
    queryBtn() {
      this.currentPage = 1;
      this.params.beginIndex = 0;
      this.getData();
    },
    onStatusTabChange(tab) {
      this.activeStatusTab = tab.name;
      this.currentPage = 1;
      this.params.beginIndex = 0;
      this.cancelSelected();
      this.getData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.params.beginIndex = (page - 1) * this.params.pageSize;
      this.getData();
    },
    handleSelectionChange(selection) {
      const selectedMap = {};
      this.multipleSelection = (selection || []).filter(row => {
        const orderId = row.orderId || row._id;
        if (!orderId || row._orderRowSpan <= 0 || selectedMap[orderId]) {
          return false;
        }
        selectedMap[orderId] = true;
        return true;
      });
    },
    getOrderProductLines(orderRow) {
      const orderId = String((orderRow && (orderRow.orderId || orderRow._id)) || "");
      if (!orderId) return [];
      return (this.tableData || [])
        .filter(row => String(row.orderId || row._id) === orderId)
        .map(line => ({
          productType: line.productType,
          productName: line.styleName || line.productName || "",
          unitPrice: line.unitPrice,
          quantity: line.quantity,
        }));
    },
    cancelSelected() {
      this.multipleSelection = [];
      this.$refs.table && this.$refs.table.clearSelection();
    },
    rowSelectable(row) {
      return row._orderRowSpan > 0;
    },
    getTableRowKey(row) {
      return row._tableRowKey || `${row.orderId || row._id}-${row._lineIndex || 0}`;
    },
    getOrderRowIndex(row) {
      let orderIndex = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i]._orderRowSpan > 0) {
          orderIndex++;
          if ((this.tableData[i].orderId || this.tableData[i]._id) === (row.orderId || row._id)) {
            return this.params.beginIndex + orderIndex;
          }
        }
      }
      return "";
    },
    tableCellClassName({ column }) {
      const classNames = ["table-cell"];
      if (ORDER_MERGE_PROPS.includes(column.property) || column.label === ACTION_COLUMN_LABEL) {
        classNames.push("merge-col");
      }
      if (column.type === "selection" || column.label === "序号") {
        classNames.push("merge-col");
      }
      return classNames.join(" ");
    },
    spanMethod({ row, column }) {
      if (ORDER_MERGE_PROPS.includes(column.property) || column.type === "selection" || column.label === "序号" || column.label === ACTION_COLUMN_LABEL) {
        const rowspan = row._orderRowSpan || 0;
        return { rowspan, colspan: rowspan > 0 ? 1 : 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    formatNumber(value) {
      if (value === "" || value === null || value === undefined) {
        return "0.00";
      }
      return parseFloat(value).toFixed(2);
    },
    getLogisticsNoList(row) {
      if (!row) return [];
      if (Array.isArray(row.logisticsNos) && row.logisticsNos.length) {
        return row.logisticsNos.map(item => String(item || "").trim()).filter(Boolean);
      }
      const label = String(row.logisticsNo || "").trim();
      if (!label) return [];
      return label
        .split(/[,，;；\s]+/)
        .map(item => item.trim())
        .filter(Boolean);
    },
    formatRefundAmount(value) {
      if (value === "" || value === null || value === undefined || value === "-") {
        return "-";
      }
      return this.formatNumber(value);
    },
    formatTaxRate(value) {
      if (value === "" || value === null || value === undefined) {
        return "0%";
      }
      return (parseFloat(value) * 100).toFixed(0) + "%";
    },
    formatAmountDiff(value) {
      const diff = parseFloat(value) || 0;
      if (diff > 0) {
        return "+" + this.formatNumber(diff);
      }
      return this.formatNumber(diff);
    },
    getAmountDiffClass(value) {
      const diff = parseFloat(value) || 0;
      if (diff > 0) return "positive";
      if (diff < 0) return "negative";
      return "zero";
    },
    getTableSummaries({ columns, data }) {
      const groupFirstRows = (data || []).filter(row => row._orderRowSpan > 0);
      const sums = [];
      columns.forEach((column, index) => {
        if (column.type === "selection") {
          sums[index] = "";
          return;
        }
        if (column.label === "序号") {
          sums[index] = "合计";
          return;
        }
        if (column.property === "quantity") {
          sums[index] = (data || []).reduce((sum, row) => sum + (Number(row.quantity) || 0), 0);
          return;
        }
        if (["arrived", "qualityFail", "exchangedQty", "outOfStock", "overStock"].includes(column.property)) {
          sums[index] = (data || []).reduce((sum, row) => sum + (Number(row[column.property]) || 0), 0);
          return;
        }
        if (["totalPrice", "taxAmount"].includes(column.property)) {
          sums[index] = this.formatNumber((data || []).reduce((sum, row) => sum + (parseFloat(row[column.property]) || 0), 0));
          return;
        }
        if (["freight", "platformDiscount", "returnExchangeFee", "otherFee", "payableAmount", "actualPaidAmount"].includes(column.property)) {
          sums[index] = this.formatNumber(groupFirstRows.reduce((sum, row) => sum + (parseFloat(row[column.property]) || 0), 0));
          return;
        }
        if (["expectedRefundAmount", "actualRefundAmount"].includes(column.property)) {
          const hasValue = groupFirstRows.some(row => row[column.property] !== "" && row[column.property] !== null && row[column.property] !== undefined && row[column.property] !== "-");
          sums[index] = hasValue ? this.formatNumber(groupFirstRows.reduce((sum, row) => sum + (parseFloat(row[column.property]) || 0), 0)) : "-";
          return;
        }
        if (column.property === "amountDiff") {
          sums[index] = this.formatAmountDiff(groupFirstRows.reduce((sum, row) => sum + (parseFloat(row.amountDiff) || 0), 0));
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    getRowsForAction(action) {
      if (action.key === "confirmReceipt") {
        return (this.multipleSelection || []).filter(row => this.canConfirmReceipt(row));
      }
      if (action.key === "createExchange") {
        return (this.multipleSelection || []).filter(row => this.canCreateExchange(row));
      }
      if (action.key === "voidReceipt") {
        return (this.multipleSelection || []).filter(row => this.canVoidReceipt(row));
      }
      if (action.key === "viewReceiptDefect") {
        return (this.multipleSelection || []).filter(row => this.canViewReceiptDefect(row));
      }
      if (action.key === "startRefund") {
        return (this.multipleSelection || []).filter(row => this.canStartRefund(row) || this.canCreateRefundFromPending(row));
      }
      if (action.key === "startReturn") {
        return (this.multipleSelection || []).filter(row => this.canStartReturn(row));
      }
      if (action.key === "startReturnRefund") {
        return (this.multipleSelection || []).filter(row => this.canStartReturnRefund(row));
      }
      if (action.key === "skipReturnAndRefund") {
        return (this.multipleSelection || []).filter(row => this.canSkipReturnAndRefund(row));
      }
      if (action.key === "skipReturnNeedRefund") {
        return (this.multipleSelection || []).filter(row => this.canSkipReturnNeedRefund(row));
      }
      if (action.key === "confirmInbound") {
        return (this.multipleSelection || []).filter(row => this.canConfirmInbound(row));
      }
      if (action.key === "createPayOrder") {
        return (this.multipleSelection || []).filter(row => this.canCreatePayOrder(row));
      }
      return (this.multipleSelection || []).filter(row => action.statuses.includes(this.resolveRowStatus(row)));
    },
    onActionClick(action) {
      const disableTip = this.actionDisableTip(action);
      if (disableTip) {
        this.$message.warning(disableTip);
        return;
      }
      const rows = this.getRowsForAction(action);
      if (!rows.length) {
        this.$message.warning("请选择符合操作条件的采购单");
        return;
      }

      if (action.key === "createPayOrder") {
        this.$refs.createPayOrderDialog && this.$refs.createPayOrderDialog.open(rows);
        return;
      }

      if (action.key === "confirmReceipt") {
        this.$refs.receiptDialog && this.$refs.receiptDialog.open(rows);
        return;
      }

      if (action.key === "createExchange") {
        const orderIds = [
          ...new Set(
            rows.map(row => String(row.purchaseOrderId || row.orderId || row._id || "")).filter(Boolean)
          ),
        ];
        if (orderIds.length > 1) {
          this.$message.warning("每次只能对一张采购单新增换货单");
          return;
        }
        this.$refs.exchangeDialog && this.$refs.exchangeDialog.open(rows);
        return;
      }

      if (action.key === "uploadLogisticsWaybill") {
        if (rows.length !== 1) {
          this.$message.warning("每次只能对一张采购单上传物流面单");
          return;
        }
        const orderRow = rows[0];
        this.$refs.uploadLogisticsDialog &&
          this.$refs.uploadLogisticsDialog.open(orderRow, this.getOrderProductLines(orderRow));
        return;
      }

      if (action.key === "voidReceipt") {
        this.$refs.voidReceiptDialog && this.$refs.voidReceiptDialog.open(rows);
        return;
      }

      if (action.key === "viewReceiptDefect") {
        this.$refs.receiptDefectDialog && this.$refs.receiptDefectDialog.open(rows);
        return;
      }

      if (DEFECT_ACTION_KEYS.includes(action.key)) {
        this.$refs.defectActionDialog && this.$refs.defectActionDialog.open(action.key, rows);
        return;
      }

      const tip = action.key === "void" ? `确认作废选中的 ${rows.length} 张采购单？` : `确认对选中的 ${rows.length} 张采购单执行「${action.label}」？`;
      this.$confirm(tip, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: action.danger ? "warning" : "info",
      })
        .then(() => this.doTransition(action.key, rows))
        .catch(() => {});
    },
    doTransition(action, rows) {
      if (this.actionLoading) return;
      this.actionLoading = true;
      requestModules
        .transitionPurchaseOrderStatus({
          action,
          selectedList: JSON.stringify(rows),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "操作失败");
            return;
          }
          this.$message.success("操作成功");
          this.onActionSuccess();
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          this.actionLoading = false;
        });
    },
    onActionSuccess() {
      this.cancelSelected();
      this.getData();
    },
    canEditOrder(row) {
      return this.resolveRowStatus(row) === PURCHASE_STATUS.PENDING_ORDER;
    },
    canCreatePayOrder(row) {
      if (!row || row.paymentGroupId) {
        return false;
      }
      return this.resolveRowStatus(row) === PURCHASE_STATUS.PENDING_ORDER;
    },
    openEditOrder(row) {
      if (!this.canEditOrder(row)) {
        this.$message.warning("仅待下单状态可编辑采购单");
        return;
      }
      this.$refs.editOrderDialog && this.$refs.editOrderDialog.open(row);
    },
    canManageOrderConfirmProof(row) {
      return this.resolveRowStatus(row) !== PURCHASE_STATUS.VOID;
    },
    getOrderConfirmProofButtonLabel(row) {
      return this.getProofImageList(row, "orderConfirmProof").length ? "编辑订单确认证明" : "上传订单确认证明";
    },
    normalizeProofImageList(value) {
      if (value == null || value === "") {
        return [];
      }
      if (Array.isArray(value)) {
        return value.map(item => String(item || "").trim()).filter(Boolean);
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) {
          return [];
        }
        if (trimmed.charAt(0) === "[") {
          try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
              return parsed.map(item => String(item || "").trim()).filter(Boolean);
            }
          } catch (error) {
            return [trimmed];
          }
        }
        return [trimmed];
      }
      return [];
    },
    getProofImageList(row, field) {
      return this.normalizeProofImageList(row && row[field]);
    },
    openProofUpload(row) {
      if (!this.canManageOrderConfirmProof(row)) {
        this.$message.warning("已作废采购单不可上传证明");
        return;
      }
      this.proofUploadRow = row;
      this.proofUploadUrls = [...this.getProofImageList(row, "orderConfirmProof")];
      this.proofUploadTitle = this.getOrderConfirmProofButtonLabel(row);
      this.proofUploadVisible = true;
    },
    onProofUploadDialogOpened() {
      document.addEventListener("paste", this.handleProofPaste);
      this.$nextTick(() => {
        if (this.$refs.proofPastePanel) {
          this.$refs.proofPastePanel.focus();
        }
      });
    },
    onProofUploadDialogClosed() {
      document.removeEventListener("paste", this.handleProofPaste);
      this.proofUploading = false;
      this.proofUploadRow = null;
      this.proofUploadUrls = [];
    },
    isProofImageFile(file) {
      if (!file) {
        return false;
      }
      if (file.type && file.type.indexOf("image/") === 0) {
        return true;
      }
      const name = (file.name || "").toLowerCase();
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/.test(name);
    },
    beforeProofImageUpload(file) {
      if (!this.isProofImageFile(file)) {
        this.$message.error("请上传图片文件");
        return false;
      }
      return true;
    },
    handleProofPaste(event) {
      if (!this.proofUploadVisible || this.proofUploading) {
        return;
      }
      const items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          const file = item.getAsFile();
          if (file) {
            this.uploadProofImageFile(file);
          }
          return;
        }
      }
    },
    uploadProofImageFile(file) {
      if (!this.isProofImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "purchaseOrder");
      this.proofUploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            this.proofUploadUrls.push(res.objData.fileUrl);
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.proofUploading = false;
        });
    },
    handleProofUploadSuccess(res) {
      if (res && res.objData && res.objData.fileUrl) {
        this.proofUploadUrls.push(res.objData.fileUrl);
        return;
      }
      this.$message.error("上传失败");
    },
    removeProofUploadImage(index) {
      this.proofUploadUrls.splice(index, 1);
    },
    saveProofUpload() {
      if (!this.proofUploadRow) {
        return;
      }
      if (!this.proofUploadUrls.length) {
        this.$message.error("请先上传图片");
        return;
      }
      const orderId = this.proofUploadRow.orderId || this.proofUploadRow._id;
      if (!orderId) {
        this.$message.warning("缺少采购单ID");
        return;
      }
      this.proofUploadSaving = true;
      requestModules
        .updatePurchaseOrderAttachment({
          orderId,
          orderConfirmProof: JSON.stringify(this.proofUploadUrls),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "保存失败");
            return;
          }
          this.$message.success("保存成功");
          this.proofUploadVisible = false;
          this.getData();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "保存失败");
        })
        .finally(() => {
          this.proofUploadSaving = false;
        });
    },
    openReceiptHistory(row) {
      this.$refs.receiptHistoryDialog && this.$refs.receiptHistoryDialog.open(row);
    },
    openPurchaseRecords(row) {
      const orderId = row && (row.orderId || row._id);
      if (!orderId) {
        this.$message.warning("缺少采购单ID");
        return;
      }
      this.purchaseRecords = [];
      this.purchaseRecordsVisible = true;
      this.purchaseRecordsLoading = true;
      requestModules
        .fetchPurchaseOrderPurchaseRecords({ orderId })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取采购记录失败");
            return;
          }
          this.purchaseRecords = res.ldata || [];
          if (!this.purchaseRecords.length) {
            this.$message.info("暂无关联采购记录");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取采购记录失败");
        })
        .finally(() => {
          this.purchaseRecordsLoading = false;
        });
    },
    getPurchaseMaterialSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "quantity") {
          sums[index] = (data || []).reduce((sum, row) => sum + (Number(row.quantity) || 0), 0);
          return;
        }
        if (column.property === "totalAmount") {
          sums[index] = this.formatNumber((data || []).reduce((sum, row) => sum + (parseFloat(row.totalAmount) || 0), 0));
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    openPurchaseMaterials(row) {
      const orderId = row && (row.orderId || row._id);
      if (!orderId) {
        this.$message.warning("缺少采购单ID");
        return;
      }
      this.purchaseMaterialVisible = true;
      this.purchaseMaterialLoading = true;
      this.purchaseMaterialList = [];
      requestModules
        .fetchPurchaseOrderPurchaseMaterials({ orderId })
        .then(res => {
          if (res.result !== 1) {
            this.purchaseMaterialVisible = false;
            this.$message.error(res.message || "获取采购材料失败");
            return;
          }
          this.purchaseMaterialList = res.ldata || [];
          if (!this.purchaseMaterialList.length) {
            this.purchaseMaterialVisible = false;
            this.$message.info("暂无关联采购材料");
          }
        })
        .catch(err => {
          this.purchaseMaterialVisible = false;
          this.$message.error((err && err.message) || "获取采购材料失败");
        })
        .finally(() => {
          this.purchaseMaterialLoading = false;
        });
    },
    showOpreateLog(row) {
      const orderId = row && (row.orderId || row._id);
      if (!orderId) {
        this.$message.warning("缺少采购单ID");
        return;
      }
      this.operateHistory = [];
      this.opreateLogVisible = true;
      this.opreateLogLoading = true;
      requestModules
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          bussinessId: orderId,
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取操作记录失败");
            return;
          }
          this.operateHistory = res.ldata || [];
          if (!this.operateHistory.length) {
            this.$message.info("暂无操作记录");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        })
        .finally(() => {
          this.opreateLogLoading = false;
        });
    },
    getData() {
      this.loading = true;

      let params = {
        ...this.params,
        statusTab: this.activeStatusTab === "all" ? "" : this.activeStatusTab,
      };

      params.productTypeList = JSON.stringify(this.productTypeList || []);
      params.supplierIdList = JSON.stringify((this.supplierIdList || []).map(id => id.toString()));
      params.productModel = this.params.productModel || "";

      if (this.date && this.date.length == 2) {
        params.beginDate = this.date[0].format("yyyy-MM-dd");
        params.endDate = this.date[1].format("yyyy-MM-dd");
      } else {
        params.beginDate = "";
        params.endDate = "";
      }

      requestModules
        .fetchPurchaseOrders(params)
        .then(res => {
          this.tableData = (res.ldata || []).map((row, index) => ({
            ...row,
            _tableRowKey: `${row.orderId || row._id || "order"}-${row._lineIndex || 0}-${index}`,
          }));
          this.total = res.total || 0;
          this.multipleSelection = [];
          this.statusCounts = {
            [String(PURCHASE_STATUS.PENDING_ORDER)]: 0,
            [String(PURCHASE_STATUS.PENDING_PAY)]: 0,
            [String(PURCHASE_STATUS.PENDING_RECEIVE)]: 0,
            [String(PURCHASE_STATUS.INBOUND_DEFECT)]: 0,
            [String(PURCHASE_STATUS.PENDING_REFUND)]: 0,
            [String(PURCHASE_STATUS.PENDING_RETURN)]: 0,
            ...(res.mdata && res.mdata.statusCounts ? res.mdata.statusCounts : {}),
          };
        })
        .finally(() => {
          this.loading = false;
          this.relayoutTable();
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#PurchaseOrderMgmt {
  .action-cell {
    white-space: nowrap;
  }

  .obligation-hints {
    margin-top: 2px;
    line-height: 1.3;
  }

  .obligation-hint {
    display: block;
    font-size: 11px;
    color: #e6a23c;
  }

  .batch-toolbar {
    .toolbar-btn-wrap {
      display: inline-block;
      margin-right: 8px;
      vertical-align: middle;

      .el-button {
        margin-right: 0;
      }
    }

    .toolbar-action-btn {
      height: auto !important;
      min-height: 32px;
      padding: 7px 15px !important;
      line-height: 1.3 !important;
      white-space: nowrap !important;
      overflow: visible !important;
      vertical-align: middle;
      box-sizing: border-box;

      > span {
        display: inline-block;
        white-space: nowrap !important;
        line-height: 1.3;
        overflow: visible;
      }
    }

    .action-btn-long-label {
      min-width: 110px;
      letter-spacing: 0;
    }

    .action-btn-create-pay-order {
      min-width: 128px;
      padding-left: 14px !important;
      padding-right: 14px !important;
    }

    .action-btn-create-receipt {
      min-width: 108px;
      padding-left: 14px !important;
      padding-right: 14px !important;
    }

    .action-btn-create-exchange {
      min-width: 108px;
      padding-left: 14px !important;
      padding-right: 14px !important;
    }

    .action-btn-skip-return-refund {
      font-weight: 500;
    }
  }

  .inner-line-table {
    margin: 8px 12px 12px 48px;
  }

  .mgmt-table {
    .el-table__body td .cell,
    .el-table__header th .cell {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      line-height: 23px;
    }

    .el-table__body td.merge-col .proof-thumb-list,
    .el-table__body td.merge-col .proof-thumb-list + .proof-empty {
      white-space: normal;
    }

    .el-table__body td.logistics-no-col {
      vertical-align: top;
    }

    .el-table__body td.logistics-no-col .cell {
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      line-height: 1.35;
      height: auto !important;
    }

    .logistics-no-list {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 4px 0;
      align-items: flex-start;
    }

    .logistics-no-item {
      word-break: break-all;
      white-space: normal;
      line-height: 1.35;
    }

    .el-table__body tr,
    .el-table__fixed .el-table__body tr,
    .el-table__fixed-right .el-table__body tr {
      height: auto;
      min-height: 36px;
    }

    .el-table__fixed,
    .el-table__fixed-right {
      height: 100% !important;
    }

    .el-table__fixed-body-wrapper .el-table__body,
    .el-table__body-wrapper .el-table__body {
      width: 100%;
    }

    .proof-thumb-list {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      justify-content: center;
      padding: 2px 0;
    }

    .proof-thumb {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      vertical-align: middle;
    }

    .proof-empty {
      color: #c0c4cc;
    }
  }
}

.purchase-order-proof-dialog {
  .proof-upload-panel {
    outline: none;
  }

  .proof-upload-panel:focus {
    outline: none;
  }

  .proof-upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    min-height: 120px;
  }

  .proof-upload-item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #ebeef5;
  }

  .proof-upload-image {
    width: 120px;
    height: 120px;
  }

  .proof-upload-remove {
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 18px;
    color: #f56c6c;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 50%;
  }

  .proof-upload-add .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
  }

  .proof-upload-add .el-upload:hover {
    border-color: #409eff;
  }

  .proof-upload-trigger {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    line-height: 1;
    text-align: center;
  }

  .proof-upload-text {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
  }

  .proof-upload-tip {
    margin-top: 12px;
    font-size: 12px;
    color: #909399;
    text-align: center;
    line-height: 1.6;
  }
}
</style>
